import Vue from "vue";
import VueScheduler from "v-calendar-scheduler";
// import "v-calendar-scheduler/lib/main.css";

Vue.use(VueScheduler, {
    labels: {
        today: "Today",
        back: "",
        next: "",
        month: "Month M",
        week: "Week W",
        day: "Day D",
        all_day: "All Day"
    },
    initialDate: new Date(),
    use12: true
});
